<template>
  <div class="context">
    <p class="title">クレジット</p>
    <p class="item">
      利用者は、本機能を利用したサービスを提供する場合には、下記のクレジット表示をお願いします。<br />
      <br />
      「このサービスは、「やまなしデータプラットフォーム」のAPI
      機能を使用していますが、サービスの内容は山梨県によって保証されたものではありません。」<br />
      <br />
      なお、利用される方が参照できる場所であれば、表示場所の指定はありません。
    </p>
  </div>
</template>
<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.item {
  font-size: 1.4vw;
}
</style>
